import { render, staticRenderFns } from "./MobilityForm.vue?vue&type=template&id=58f9a31a&scoped=true"
import script from "./MobilityForm.vue?vue&type=script&lang=js"
export * from "./MobilityForm.vue?vue&type=script&lang=js"
import style0 from "./MobilityForm.vue?vue&type=style&index=0&id=58f9a31a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f9a31a",
  null
  
)

export default component.exports